import coreStore from './core-store'
import utils from '../utils/utils'
import * as _ from 'lodash'
import Axios from 'axios'

const remoteResource = 'operation/api/v1/operations'

const store = function (operationDefinitionId) {
    return {
        namespaced: true,
        state: function () {
            return {
                createdItems: [],
                actualPageItems: [],
                actualPage: 0,
                pageSize: 20,
                totalCount: Number.NaN,
                coreFilter: {
                    name: "temp-query",
                    object: "operation",
                    parameters: {
                        operationDefinition: {
                            operator: "eq",
                            type: "string",
                            value: operationDefinitionId
                        },
                        actualStatus: {type: 'enum', operator: 'in', value: 'LIVE', negation: false}
                    }
                },
                currentSort: {
                    sortField: null,
                    direction: null
                }
            }
        },
        getters: {
            getCreatedItems: (state) => state.createdItems,
            getActualPageItems: (state) => state.actualPageItems,
            getActualPage: (state) => state.actualPage,
            getPageSize: (state) => state.pageSize,
            getPaginationController: (state, getters) => ({
                pages: Math.ceil(state.totalCount / state.pageSize),
                actualPage: state.actualPage,
                pageSize: state.pageSize,
                actualItems: getters.getActualPageItems.length,
                totalItems: state.totalCount
            })
        },
        mutations: {
            addCreatedOperation(store, operation) {
                const originalIndex = store.createdItems.findIndex(op => operation.id == op.id);
                if (originalIndex != -1) {
                    store.createdItems.splice(originalIndex, 1);
                }
                store.createdItems.push(operation);

            },
            clearCreatedOperations(store) {
                store.createdItems = [];
            },
            clearOperations(store) {
                store.actualPageItems.clear();
                store.actualPage = 0;
            },
            setOperationPage(store, page) {
                page.list.forEach(item => {
                    const foundItem = store.createdItems.find(op => item.id == op.id);
                    if (foundItem) Object.assign(foundItem, item);
                });
                store.actualPageItems = page.list;
                store.actualPage = page.meta.page;
                store.pageSize = page.meta.pageSize;
                store.totalCount = page.meta.count;
            },
            setCurrentSort(store, sort) {
                store.currentSort.sortField = sort?.sortField ?? null;
                store.currentSort.direction = sort?.direction === 'DESC' ? -1 : 1 ?? null;
            }
        },
        actions: {
            downloadCsv: async function ({state, commit}, {query}) {
                let searchQuery = _.cloneDeep(state.coreFilter);
                if (query != null) {
                    Object.assign(searchQuery, query);
                }
                searchQuery = encodeURIComponent(JSON.stringify(searchQuery));
                let sorting = "";
                if (state.currentSort.sortField != null) {
                    sorting += "&sortField=" + state.currentSort.sortField
                    sorting += "&sortDirection=" + state.currentSort.direction
                }

                let url = `${remoteResource}/csv?size=200000&page=0&query=${searchQuery}`;
                // const link = document.createElement('a')
                // link.href = url
                // link.setAttribute('download', 'operations.csv') //or any other extension
                // document.body.appendChild(link)
                // link.click()
                // document.body.removeChild(link);
                const response = await Axios.get(url, {
                    responseType: 'blob', // Set the response type to blob
                });

                // Create a temporary link to download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'operations.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            refreshOperations: _.throttle(function ({state, commit}, {requestedPage, query, sort, size}) {
                let searchQuery = _.cloneDeep(state.coreFilter);
                if(sort) {
                    commit('setCurrentSort', sort)
                }
                if (query != null) {
                    Object.assign(searchQuery, query);
                }
                searchQuery = encodeURIComponent(JSON.stringify(searchQuery));
                let sorting = "";
                if (state.currentSort.sortField != null) {
                    sorting += "&sortField=" + state.currentSort.sortField
                    sorting += "&sortDirection=" + state.currentSort.direction
                }

                return Axios.get(`${remoteResource}?size=${size ?? state.pageSize}&page=${requestedPage}&query=${searchQuery}${sorting}`)
                    .then(utils.parsePageResponse)
                    .then(page => {
                        commit('setOperationPage', page);
                    })
            }, 1000),
            fetchSingleOperation: function ({state}, {id}) {
                return Axios.get(`${remoteResource}/${id}`);
            },
            fetchOperations: function ({state}, {requestedPage, query, sort, size}) {
                let searchQuery = _.cloneDeep(state.coreFilter);
                if (query) {
                    Object.assign(searchQuery, query);
                }
                searchQuery = encodeURIComponent(JSON.stringify(searchQuery));
                let sorting = "";
                if (sort) {
                    sorting += "&sortField=" + sort.sortField
                    sorting += "&sortDirection=" + sort.direction
                }

                return Axios.get(`${remoteResource}?size=${size}&page=${requestedPage}&query=${searchQuery}${sorting}`)
                    .then(utils.parsePageResponse)
            },
            changePageSize({commit, dispatch, state}, pageSize) {
                state.pageSize = pageSize;
                commit('clearOperations');
                return dispatch('refreshOperations', {requestedPage: 0});
            },
            saveOperation: async function ({state, commit, dispatch}, operation) {
                if (operation.id == undefined || operation.id == null) {
                    let createdOperationLocation = (await Axios.post(`${remoteResource}`, operation)).headers.location;
                    let createdOperation = (await Axios.get(createdOperationLocation)).data;
                    commit('addCreatedOperation', createdOperation);
                    return createdOperation;
                } else {
                    await Axios.put(`${remoteResource}/${operation.id}`, operation)
                    commit('addCreatedOperation', operation);
                    return operation;

                }

            },
            deleteOperationsByQuery({state, commit, dispatch}, query) {
                return Axios.delete(`${remoteResource}?query=${encodeURI(JSON.stringify(query))}`)
            },
            deleteOperation({state, commit, dispatch}, operation) {
                return Axios.delete(`${remoteResource}/${operation.id}`)
            }
        }
    }
}

export default store;
